import * as React from "react";
import { withIntl } from "@grandvisionhq/state";
import { CartCounter } from "../../CartCounter/CartCounter/CartCounter.js";
import { getCartTotalsTitle } from "../../Util/Util/get-cart-totals-title.js";
/* empty css                */
const _CartButton = class _CartButton extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      count: 0
    };
    this.onStoredCartChange = () => {
      const count = _CartButton.getCartCount();
      this.setState({ count });
    };
  }
  static getCartCount() {
    const fromStorage = window.localStorage.getItem("stored_cart");
    if (!fromStorage) {
      return 0;
    }
    const cart = JSON.parse(fromStorage);
    return cart && cart.cartId ? cart.cartCount : 0;
  }
  componentDidMount() {
    const count = _CartButton.getCartCount();
    this.setState({ count });
    window.addEventListener("cart.change", this.onStoredCartChange);
    window.addEventListener("storage", this.onStoredCartChange);
  }
  componentWillUnmount() {
    window.removeEventListener("storage", this.onStoredCartChange);
    window.removeEventListener("cart.change", this.onStoredCartChange);
  }
  render() {
    const { count } = this.state;
    const { href, className, intl, label, tabIndex, tealiumAttributes } = this.props;
    const ariaLabel = count === 0 ? intl.getLabel("cart.emptyCart.title") : getCartTotalsTitle(
      count,
      intl,
      "cart.minicart.totalsTitle.singular",
      "cart.minicart.totalsTitle"
    );
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        className: `cart-button ${className || ""}`,
        href,
        title: label,
        tabIndex,
        "aria-label": tabIndex === -1 ? "" : ariaLabel,
        ...tealiumAttributes
      },
      /* @__PURE__ */ React.createElement(CartCounter, { count })
    );
  }
};
_CartButton.defaultProps = {
  href: "/cart",
  tabIndex: void 0
};
let CartButton = _CartButton;
const CartButton$1 = withIntl(CartButton);
export {
  CartButton$1 as default
};
//# sourceMappingURL=CartButton.js.map
